import { type EidCategoryItem } from '@app/client/common/structs/emoji/emoji';

import {
    ACTION_SET_ADDRESS_STRING,
    ACTION_SET_ORGANIZATION,
    ACTION_SET_PARTNER_CONVERSION_ID,
    ACTION_SET_WALLET_ADDRESSES,
    ACTION_SET_WALLET_DATA,
    ACTION_SET_WALLET_LINK_SUCCESS,
    type PartnerIntegrationActionTypes,
    type PartnerIntegrationsState,
} from '../types/partner-integrations';

const DEFAULT: PartnerIntegrationsState = {
    walletData: undefined,
    appCurrencyTags: [],
    organization: null,
    linkSuccess: false,
    walletAddresses: [],
    walletAddressTypes: [],
    walletAddressData: [],
    partnerConversionId: '',
};

export function partnerIntegrations(
    state: PartnerIntegrationsState = DEFAULT,
    action: PartnerIntegrationActionTypes,
): PartnerIntegrationsState {
    switch (action.type) {
        case ACTION_SET_WALLET_DATA: {
            const allowed: string[] = [];
            const curr = action.walletData.currencies;
            curr?.forEach((currency) => {
                allowed.push('0x' + (+currency).toString(16).padStart(4, '0'));
            });
            return { ...state, walletData: action.walletData, appCurrencyTags: allowed };
        }
        case ACTION_SET_ORGANIZATION:
            return { ...state, organization: action.organization };
        case ACTION_SET_WALLET_LINK_SUCCESS:
            return { ...state, linkSuccess: action.linkSuccess };
        case ACTION_SET_WALLET_ADDRESSES: {
            const walletAddressTypes: EidCategoryItem[] = [];
            Object.keys(action.walletAddresses).forEach((address) =>
                walletAddressTypes.push(action.walletAddresses[address].tag),
            );
            return <PartnerIntegrationsState>{
                ...state,
                walletAddresses: action.walletAddresses,
                walletAddressData: action.walletAddressData,
                walletAddressTypes,
            };
        }
        case ACTION_SET_PARTNER_CONVERSION_ID:
            return { ...state, partnerConversionId: action.partnerConversionId };
        case ACTION_SET_ADDRESS_STRING:
            return { ...state, walletAddresses: action.walletAddresses };
        default:
            return { ...state };
    }
}
